import httpClient from "../utils/httpClient";

export const getReportListApi = async (payload) => {
    const response = await httpClient.post("/Reports/GetReportList", payload);
    return response.data;
};

export const generateReportApi = async (payload) => {
    const response = await httpClient.post("/Reports/GenerateReport", payload);
    return response.data;
};